export default __webpack_public_path__ + "static/media/icon-flag-swiss.c6fa3dd5.svg";